import React from 'react'
import styled from 'styled-components'
import {translate} from 'react-i18next'
import {Recaptcha} from 'components/recaptcha'

const CaptchaErrorContainer = styled.div`
  border: ${props => (props.error ? '1px solid #E2001A' : 'none')};
  width: 302px;
  display: inline-block;
`

const CaptchaErrorText = styled.p`
  margin: 5px;
  color: #e2001a;
  font-size: 14px;
  line-height: 20px;
  display: ${props => (props.error ? 'block' : 'none')};
`

const Captcha = ({onChange, hl, error, t}) => (
  <CaptchaErrorContainer error={!!error}>
    <Recaptcha onChange={onChange} hl={hl} />
    <CaptchaErrorText error={!!error}>{t('validation.captcha-empty')}</CaptchaErrorText>
  </CaptchaErrorContainer>
)

export default translate()(Captcha)
